import styled from "styled-components";
import { rgba } from "polished";

/*
 * Alturas enxutas de proposito. O cabecalho da agenda e FIXO: cada pixel que
 * ele ocupa e um pixel a menos de grade, e em notebook sobrava pouco mais de
 * uma faixa de horarios visivel. Nada foi removido — so apertado.
 */
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  padding: 6px 12px;

  /*
   * Em tela larga, controles e dias dividem UMA linha em vez de duas. Era a
   * linha da data inteira (~36px) gasta so para repetir o dia que ja esta
   * marcado na tira logo abaixo. Em tela estreita volta a empilhar, senao os
   * dias ficariam finos demais para o dedo.
   */
  @media (min-width: 1100px) {
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px ${(props) => rgba(props.theme.colors.black, 0.06)};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (min-width: 1100px) {
    flex: 0 0 auto;
    flex-wrap: nowrap;
    padding-right: 12px;
    border-right: 1px solid ${(props) => props.theme.colors.gray[200]};
  }
`;

export const TodayButton = styled.button`
  height: 30px;
  padding: 0 14px;
  border: 1px solid ${(props) => props.theme.colors.gray[200]};
  border-radius: 10px;
  background: #fff;
  color: ${(props) => props.theme.colors.gray[800]};
  font-size: 14px;
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    border-color: ${(props) => props.theme.colors.scale[400]};
    color: ${(props) => props.theme.colors.scale[600]};
  }
  &:active {
    transform: scale(0.97);
  }
`;

export const StepButton = styled.button`
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: none;
  color: ${(props) => props.theme.colors.gray[700]};
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    background: ${(props) => rgba(props.theme.colors.scale[300], 0.25)};
    color: ${(props) => props.theme.colors.scale[600]};
  }
  &:active {
    transform: scale(0.94);
  }
`;

/*
 * A data virou botao. Ela ja vinha com icone de calendario, mas era texto
 * puro: o icone prometia um calendario que nao abria. Agora abre.
 */
export const CurrentDate = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.gray[800]};
  white-space: nowrap;
  text-transform: capitalize;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 2px 8px;
  cursor: pointer;

  &:hover {
    border-color: ${(props) => props.theme.colors.gray[200]};
    background: ${(props) => props.theme.colors.gray[50]};
  }

  &[aria-expanded="true"] {
    border-color: ${(props) => props.theme.colors.scale[500]};
    background: #fff;
  }

  svg {
    color: ${(props) => props.theme.colors.scale[500]};
    flex-shrink: 0;
  }

  /* em monitor pequeno a data por extenso nao cabe ao lado dos controles */
  @media (max-width: 900px) {
    font-size: 14px;
    white-space: normal;
  }
`;

/* a caixa so existe para ancorar o calendario embaixo da data */
export const DateAnchor = styled.div`
  position: relative;
`;

export const CalendarPopup = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 60;
  padding: 12px;
  background: #fff;
  border: 1px solid ${(props) => props.theme.colors.gray[200]};
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);

  /* em tela estreita o calendario sairia pela direita se ficasse preso a esquerda */
  @media (max-width: 640px) {
    left: auto;
    right: 0;
  }
`;

export const Week = styled.div`
  @media (min-width: 1100px) {
    flex: 1 1 auto;
    min-width: 0;
  }

  /* mostra duas semanas e deixa o espaco disponivel ser preenchido por dias,
     em vez de esticar sete deles pela tela inteira. Em tela estreita os dias
     da segunda semana saem de cena, ficando so a semana do dia escolhido. */
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 4px;

  @media (max-width: 1500px) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
    > *:nth-child(n + 12) {
      display: none;
    }
  }

  @media (max-width: 1150px) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
    > *:nth-child(n + 8) {
      display: none;
    }
  }
`;

export const Day = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 2px 4px;
  border: none;
  border-radius: 8px;
  background: ${(props) =>
    props.$selected ? props.theme.colors.scale[500] : "transparent"};
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    background: ${(props) =>
    props.$selected
      ? props.theme.colors.scale[500]
      : rgba(props.theme.colors.scale[300], 0.25)};
  }
  &:active {
    transform: scale(0.97);
  }

  strong {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: ${(props) =>
    props.$selected
      ? "#fff"
      : props.$today
        ? props.theme.colors.scale[600]
        : props.theme.colors.gray[600]};
  }

  span {
    font-size: 15px;
    font-weight: 600;
    color: ${(props) =>
    props.$selected
      ? "#fff"
      : props.$today
        ? props.theme.colors.scale[600]
        : props.theme.colors.gray[800]};
  }

  @media (max-width: 1100px) {
    strong {
      font-size: 9px;
    }
  }
`;
